<template>

  <div class="container" v-if="review_detail">

    <!-- Header -->
    <div class="header">
      <h1>리뷰 등록하면</h1>
      <template v-if="review_detail.benefit_type=='discount'">
        <p
            style="font-size: 2.3em">{{review_detail.discount_amount.toString().price2()}}원</p>
        <p style="font-size: 2.3em">즉시 할인!</p>
      </template>
      <template v-else>
        <p style="font-size: 2.3em">{{review_detail.benefit_detail.toString()}}</p>
        <p style="font-size: 2.3em">서비스 제공!</p>
      </template>
    </div>

    <!-- CTA Section -->
    <div class="cta-section">

      <div style="display: flex;" v-if="false">
        <div style="flex: 1;text-align: center" v-if="review_detail.instagram"><img src="/images/insta.png" style="max-width: 100%;max-height: 300px"></div>
        <div style="flex: 1;text-align: center" v-if="review_detail.naver_receipt"><img src="/images/naver.png" style="max-width: 100%;max-height: 300px"></div>
        <div style="flex: 1;text-align: center" v-if="review_detail.google_map"><img src="/images/google.png" style="max-width: 100%;max-height: 300px"></div>
      </div>

      <!--
        <p v-if="tablet_auth">리뷰를 등록하고, 등록된 리뷰 화면을 캡쳐, 아래 <b>QR 코드를</b> 촬영해서 업로드 해주시면 즉시 할인 또는 서비스를 제공해드립니다.</p>
        <p v-else>리뷰를 등록하고, 등록된 리뷰 화면을 캡쳐, 아래 <b>[제출하기]</b> 버튼을 클릭해서 업로드 해주시면 즉시 할인 또는 서비스를 제공해드립니다.</p>
        <div style="padding: 5px 0">
          * 별도 직원 호출없이 비대면으로 참여가능합니다.
        </div>

      //-->

      <div v-if="tablet_auth">

        <h2 class="cta-title">직원 호출없이<br/>비대면으로 참여합니다.</h2>
        <div style="display: flex;justify-content: center;flex-direction: column">
          <p style="font-size: 1.6em" class="tabletInfo">아래 QR 코드를 휴대폰으로 촬영해주세요</p>
          <div style="align-self: center">
            <div style="padding: 15px;background-color: white;border-radius: 10px;text-align: center;margin-top:15px">
              <qr-code :size="180" :text="getSmartorderUrl()" style="justify-content: center;align-self: center;"/>
            </div>
          </div>
        </div>


      </div>
      <template v-else>

        <h2 class="cta-title">직원 호출없이<br/>비대면으로 참여합니다.</h2>
        <p class="cta-subtitle" v-if="tablet_auth">리뷰를 등록하고<br/>등록된 리뷰 화면을 캡쳐<br/>아래 <b>QR 코드를</b> 촬영해서 업로드 해주시면 즉시 할인 또는 서비스를 제공해드립니다.</p>
        <p class="cta-subtitle" v-else>리뷰를 등록하고<br/>등록된 리뷰 화면을 캡쳐<br/>
          <b>[제출하기]</b> 버튼을 클릭해서 업로드 하면<br/>즉시 할인 또는 서비스를 제공해드립니다.</p>

        <!--
          <div class="receiptButton2" @click="download_img()" v-if="review_detail.naver_receipt">
            <p>1. 리뷰 등록 영수증 받기</p>
          </div>
          <div style="margin-top: 15px" @click="write_review" class="receiptButton2" v-if="review_detail.naver_receipt">
            <p>2. 네이버리뷰 작성하기</p>
          </div>
        //-->
        <div class="cta-buttons">
          <button @click="download_img" class="btn btn-primary">리뷰 등록 영수증 받기</button>
          <button
              v-if="review_detail.naver_receipt"
              @click="write_review" class="btn btn-primary">네이버 리뷰 작성하기</button>

          <button
              @click="submit_review"
              class="btn btn-secondary">{{$t('submit')}}</button>
        </div>


      </template>

    </div>
  </div>


<!--
  <div v-if="showDialog" class="modal-overlay">
    <div class="modal-content">
      <p>이미지를 길게 눌러서 갤러리로 저장해주세요.</p>
      <img :src="imgurl" alt="Image to Save" style="width: 100%; max-width: 300px;" />
      <button @click="showDialog=false">닫기</button>
    </div>
  </div>
//-->
</template>
<script>
import {mapGetters} from "vuex";
import axios from "axios";
import VueQRCodeComponent from 'vue-qrcode-component'
import store from "@/store";

export default {
  components: {
    'qr-code': VueQRCodeComponent,
  },
  computed:{
    ...mapGetters({
      shop_uid:'shop_uid',
      tablet_auth:'tablet_auth',
      shop_info:'shop_info',
      torder_no:'torder_no',
      review_detail: 'review_detail',
    })
  },
  watch:{
    shop_info:function () {
      this.load()
    }
  },
  methods:{
    convertToValue2: function(javaInputString) {
      try {
        // 1. Java 스타일의 문자열을 순수 JSON 문자열로 세탁
        // 예: "[\n" + "  {\n" ... 형태를 [{"pid2":...}] 형태로 변환
        const cleanJsonString = javaInputString
            .replace(/"\s*\+\s*"/g, "") // 연결 연산자 " + " 제거
            .replace(/^"|";$/g, "")      // 맨 앞, 맨 뒤의 코드용 따옴표 제거
            .replace(/\\"/g, '"')        // 이스케이프된 따옴표 복구
            .replace(/\\n/g, "");        // 줄바꿈 문자 제거

        // 2. JSON 파싱
        const items = JSON.parse(cleanJsonString);

        // 3. value2 목표 포맷에 맞게 데이터 매핑
        // (원본에 없는 'sale', 'category_name' 필드 추가)
        const formattedItems = items.map(item => ({
          "pid2": item.pid2,
          "title": item.title,
          "price": item.price,
          "opt_name": item.opt_name || "", // opt_name이 없으면 빈 문자열
          "sale": 0,                       // *추가: 할인 금액 (기본값 0)
          "qty": item.qty,
          "total_price": item.total_price,
          "category_name": null,           // *추가: 카테고리명 (기본값 null)
          "printer_no": item.printer_no
        }));

        // 4. JSON 문자열 변환 및 URL 인코딩
        const jsonString = JSON.stringify(formattedItems);
        const encodedValue = encodeURIComponent(jsonString);

        // 5. 최종 결과 반환
        return "&value2=" + encodedValue;

      } catch (e) {
        console.error("변환 중 에러 발생:", e);
        return "";
      }
    },
    convertToJsonJavaString:function(inputData) {
      // 1. 입력 데이터를 목표 데이터 구조로 매핑
      const mappedData = inputData.map(item => ({
        pid2: item.pid2,
        title: item.name,                  // name을 title로 변경
        qty: item.qty,
        price: item.price,
        total_price: item.price * item.qty, // 총 가격 계산
        opt_name: "",                       // 기본값 (빈 문자열)
        enable_manage_status: 1,            // 기본값
        printer_no: null                    // 기본값
      }));

      return mappedData
    },
    updateUrlPriceBasedOnItems:function(urlString) {
      try {
        // 1. URL 객체 생성 (파라미터 파싱을 위해)
        const url = new URL(urlString);

        // 2. value1, value2 파라미터 가져오기 (자동 디코딩됨)
        const value1Json = url.searchParams.get('value1');
        const value2Json = url.searchParams.get('value2');

        if (!value1Json || !value2Json) {
          console.error("value1 또는 value2 파라미터가 없습니다.");
          return urlString;
        }

        // 3. JSON 파싱
        const value1 = JSON.parse(value1Json);
        const value2 = JSON.parse(value2Json);

        // 4. value2 상품 목록을 순회하며 총액 계산
        // (item.total_price가 있으면 사용하고, 없으면 price * qty 로 계산)
        const newTotalAmount = value2.reduce((sum, item) => {
          const itemTotal = item.total_price !== undefined ? item.total_price : (item.price * item.qty);
          return sum + itemTotal;
        }, 0);

        // 5. value1 의 가격 관련 필드 업데이트
        // 원본 데이터 패턴(tax:0, tax_free:전액)에 맞춰 업데이트합니다.
        value1.total_amount = newTotalAmount;
        value1.tax_free = newTotalAmount;
        value1.order_price = newTotalAmount;
        value1.supply = newTotalAmount;
        // value1.tax는 건드리지 않음 (0 유지)

        // 6. 업데이트된 value1을 다시 문자열로 변환하여 URL에 설정
        // (URLSearchParams.set이 자동으로 URL 인코딩을 수행합니다)
        url.searchParams.set('value1', JSON.stringify(value1));

        // 7. 최종 URL 반환
        return url.toString();

      } catch (e) {
        console.error("URL 변환 중 오류 발생:", e);
        return urlString;
      }
    } ,
    parse_kiosk:async function() {
      let sample = [
        {
          "pid2": 173947,
          "title": "시그니처+베이글+샌드위치",
          "qty": 1,
          "price": 7500,
          "total_price": 7500,
          "opt_name": "",
          "enable_manage_status": 1,
          "printer_no": null
        },
        {
          "pid2": 194177,
          "title": "핫/아이스+시그니처+아메리카노",
          "qty": 1,
          "price": 2800,
          "total_price": 2800,
          "opt_name": "",
          "enable_manage_status": 1,
          "printer_no": 1
        }
      ]

      let url = "/core-api/main/get/tmp_receipt_kiosk?uid=" + this.shop_info.uid + "&order_id="+this.kiosk_id
      let res = await axios.get(url)
      let data = res.data
      let n = data.indexOf("&value2=")
      data = data.substring(0, n)

      let murl = data

      // 내주문 스마트오더를 가져온다
      try {
        url = '/my-api/myshp/get/order/myinfo/smartorder?id=' + this.smartorder_id
        res = await axios.get(url)
        data = res.data[0]["data"]

        let param = this.convertToValue2(JSON.stringify(this.convertToJsonJavaString(data)))
        murl += param
      } catch (e) {
        let param = this.convertToValue2(JSON.stringify(sample))
        murl += param
      }
      murl=this.updateUrlPriceBasedOnItems(murl)
      this.imgurl = murl
    },
    parse_smartorder:async function () {
      let sample = [
        {
          "pid2": 173947,
          "title": "시그니처+베이글+샌드위치",
          "qty": 1,
          "price": 7500,
          "total_price": 7500,
          "opt_name": "",
          "enable_manage_status": 1,
          "printer_no": null
        },
        {
          "pid2": 194177,
          "title": "핫/아이스+시그니처+아메리카노",
          "qty": 1,
          "price": 2800,
          "total_price": 2800,
          "opt_name": "",
          "enable_manage_status": 1,
          "printer_no": 1
        }
      ]


      let url = "/core-api/main/get/tmp_receipt?uid=" + this.shop_info.uid + "&table_no=0"
      let res = await axios.get(url)
      let data = res.data
      let n = data.indexOf("&value2=")
      data = data.substring(0, n)

      let murl = data

      // 내주문 스마트오더를 가져온다
      try {
        url = '/my-api/myshp/get/order/myinfo/smartorder?id=' + this.smartorder_id
        res = await axios.get(url)
        data = res.data[0]["data"]

        let param = this.convertToValue2(JSON.stringify(this.convertToJsonJavaString(data)))
        murl += param
      } catch (e) {
        let param = this.convertToValue2(JSON.stringify(sample))
        murl += param
      }
      murl=this.updateUrlPriceBasedOnItems(murl)
      this.imgurl = murl
    },
    getSmartorderUrl: function() {
      let SMARTORDER_URL = store.state.my_env('smartorder')
      var url = "https://gw." + SMARTORDER_URL + "/api/main/start_order?shopid=" + this.shop_uid + "&tid=" + this.torder_no
      return url
    },
    saveImageToGallery:async function(imageUrl) {
      try {
        let that = this
        // Fetch the image as a Blob
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const file = new File([blob], "receipt.png", { type: "image/png" });

        // Check if Web Share API is supported
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({
            files: [file],
            title: "영수증 저장",
            text: "영수증을 갤러리에 저장합니다.",
          });
          alert("저장이 완료되었습니다!");
        } else {
          //alert("저장에 실패하였습니다.");
          that.download_img(true)
        }
      } catch (error) {
        console.error("Error sharing image:", error);
      }
    },
    download_img:function (force) {

      if(!this.imgurl) {
        //this.$toast.error('영수증을 만들고 있습니다. 잠시후 다시 시도해주세요.', { position: "top" });
        // 직접 조회 후 이동
        let that = this
        this.get_receipt(function() {
          that.$router.push({path:'review_receipt',query:{img:that.imgurl}})
        })
        return
      }


      const imageUrl = this.imgurl

      const isIPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (force || !isIPhone) {

        // 현재 창(팝업) 닫기
        this.emitter.emit("confirm_popup_close", {
        });


        // ok
        this.$router.push({path:'review_receipt',query:{img:imageUrl}})
        return

        // 아이폰이 아닌 경우만

      } else {
        this.saveImageToGallery(imageUrl)
        return;
      }


      try {

        let that = this

        const xhr = new XMLHttpRequest();
        xhr.open("GET", imageUrl, true);
        xhr.responseType = "blob";

// When the request completes, process the Blob response
        xhr.onload = function () {
          if (xhr.status === 200) {
            // Create a Blob from the response
            const blob = xhr.response;
            const newBlob = new Blob([blob], { type: "image/png" });


            // Create a URL for the Blob and set it as the href for a download link
            const link = document.createElement("a");
            const url = URL.createObjectURL(newBlob);
            link.href = url;
            link.download = "receipt.png"; // Specify the file name

            // Trigger the download
            link.click();

            // Clean up the Blob URL after download
            URL.revokeObjectURL(url);

            that.$toast.info('다운로드가 완료되었습니다.', { position: "top" });
          }
        };


        // Send the request
        xhr.send();

      } catch (error) {
        console.log(error)
        console.error("Error downloading the image:", error);
      }
    },
    get_receipt(callback) {

      // Image URL
      let tno = 1
      if(this.$route.query.smartorder) {
        this.smartorder_id = this.$route.query.smartorder
        this.parse_smartorder()
        return
      }
      if(this.$route.query.kiosk) {
        this.kiosk_id = this.$route.query.kiosk
        this.parse_kiosk()
        return
      }
      else if(this.$route.query.tno)
        tno = this.$route.query.tno
      else
        tno = this.torder_no

      if(!tno)
        tno = 1

      let url = "/core-api/main/get/tmp_receipt?uid=" + this.shop_info.uid + "&table_no="+tno
      axios.get(url).then(res => {
        this.imgurl = res.data

        if(callback) {
          callback()
        }
        //this.$store.commit('review_detail', { value: res.data.review_info });
      }).catch(error => {
        console.log(error)
      });
    },
    write_review() {
      window.open("https://m.place.naver.com/my/checkin")
    },
    getReviewUrl() {

      if(this.smartorder_id) {
        //https://f.myshop.do/t/dP3JB7AvQ9us?orderid=xxxxx
        let url2 = 'https://f.myshop.do/t/dP3JB7AvQ9us?shopid='+this.shop_info.uid
        url2 += '&orderid='+this.smartorder_id
        return url2
      }

      let url = 'https://f.myshop.do/t/2P5AUxsUCGus?shopid='+this.shop_info.uid
      if(this.$route.query.tno)
        url+='&table_no='+this.$route.query.tno
      else
        url+='&table_no='+this.torder_no

      return url
    },
    submit_review() {
      let url = this.getReviewUrl()
      window.open(url)
    },
    data: () => ({
      smartorder_id:null,
      kiosk_id:null,
      //showDialog:true,
      imgurl:null
    }),
    load() {
      if(!this.shop_info)
        return

      let url = "/gw-api/main/get_review_detail?shopid=" + this.shop_info.uid+'&tno='+this.torder_no;
      axios.get(url).then(res => {
        this.$store.commit('review_detail', { value: res.data.review_info });
      }).catch(error => {
        console.log(error)
        //this.$toast.error( this.$t('shop_not_ready'), { position: "top" });
      });
    }
  },
	mounted() {
    //console.log(this.tablet_auth)

    this.get_receipt()

    if(this.shop_info)
      this.load()
  }
}
</script>

<style scoped>

.container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Header Section */
.header {
  text-align: center;
  margin-bottom: 40px;
}

.header h1 {
  font-size: 42px;
  color: #2c3e50;
  margin-bottom: 15px;
  font-weight: 700;
}

.header p {
  font-size: 18px;
  color: #7f8c8d;
  max-width: 600px;
  margin: 0 auto;
}

/* Phone Cards Section */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.card {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.platform-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 24px;
  color: white;
  margin-right: 15px;
}

.instagram-bg {
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}

.naver-bg {
  background: #03C75A;
}

.google-bg {
  background: #4285F4;
}

.card-title {
  flex: 1;
}

.card-title h3 {
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 5px;
}

.rating {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #f39c12;
  font-size: 14px;
}

.phone-preview {
  width: 100%;
  height: 400px;
  background: #f8f9fa;
  border-radius: 15px;
  margin-bottom: 20px;
  padding: 20px;
  border: 2px solid #e9ecef;
}

.preview-item {
  background: white;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #e9ecef;
}

.preview-image {
  width: 100%;
  height: 100px;
  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);
  border-radius: 8px;
  margin-bottom: 10px;
}

.preview-text {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.5;
}

.card-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 10px;
  font-size: 14px;
  color: #495057;
}

.feature-icon {
  width: 20px;
  height: 20px;
  background: #6c757d;
  border-radius: 50%;
}

/* CTA Section */
.cta-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 50px;
  text-align: center;
  color: white;
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);
}

.cta-title {
  font-size: 32px;
  margin-bottom: 20px;
  font-weight: 700;
}

.cta-subtitle {
  line-height: 1.3;
  font-size: 16px;
  margin-bottom: 40px;
  opacity: 0.9;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 15px 35px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  background: white;
  color: #667eea;
}

.btn-primary:hover {
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .header h1 {
    font-size: 32px;
  }

  .platforms-row {
    gap: 30px;
  }

  .platform-logo {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }

  .cta-section {
    padding: 30px 20px;
  }

  .cta-title {
    font-size: 24px;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

/* Subtle animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: fadeIn 0.6s ease-out;
}

.card:nth-child(1) { animation-delay: 0.1s; }
.card:nth-child(2) { animation-delay: 0.2s; }
.card:nth-child(3) { animation-delay: 0.3s; }
</style>